/*
 * Turns any link whose URL ends with an `#add-to-cart` hash into the theme's
 * standard AJAX add-to-cart button (product-form pipeline: cart drawer,
 * loading spinner, error and sold-out states). No section changes needed.
 *
 *   #add-to-cart            adds the page's current product (follows the
 *                           variant picker and mirrors its sold-out state)
 *   #add-to-cart=12345      adds that specific variant id
 */
(() => {
  const productFormSrc = document.currentScript.dataset.productFormSrc;

  const SPINNER =
    '<div class="loading__spinner hidden">' +
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>' +
    '</div>';

  const marker = (link) => {
    const hash = link.hash || '';
    if (hash === '#add-to-cart') return '';
    if (hash.startsWith('#add-to-cart=')) return hash.slice(13);
    return null;
  };

  /* Scope to the main product section: the cart drawer (with upsell
     product forms) and quick-add cards render their own product-form
     elements, and the drawer's come earlier in the DOM. */
  const mainScope = () => document.querySelector('[id^="MainProduct-"]') || document;

  const mainVariantInput = () =>
    mainScope().querySelector('product-form:not(.x-add-to-cart-link) form [name="id"]');
  const mainSubmitButton = () => mainScope().querySelector('[id^="ProductSubmitButton"]');

  function syncWithMainForm(el) {
    const button = el.querySelector('[name="add"]');
    const input = el.querySelector('[name="id"]');
    input.value = mainVariantInput()?.value || input.value;
    const main = mainSubmitButton();
    if (!main) return;
    button.disabled = main.disabled;
    button.querySelector('span').textContent = main.disabled
      ? window.variantStrings?.soldOut || 'Sold out'
      : button.dataset.label;
  }

  function transform(link) {
    const variantId = marker(link);
    const template = document.createElement('template');
    template.innerHTML =
      '<product-form class="x-add-to-cart-link" style="display: contents">' +
      '<div class="product-form__error-message-wrapper" role="alert" hidden>' +
      '<span class="product-form__error-message"></span>' +
      '</div>' +
      '<form method="post" action="' + window.routes.cart_add_url + '" data-type="add-to-cart-form" style="display: contents">' +
      '<input type="hidden" name="id" value="">' +
      '<button type="submit" name="add"><span></span>' + SPINNER + '</button>' +
      '</form>' +
      '</product-form>';
    const el = template.content.firstElementChild;
    const button = el.querySelector('button');
    button.className = link.className;
    button.dataset.label = link.textContent.trim();
    button.querySelector('span').textContent = button.dataset.label;
    el.querySelector('[name="id"]').value = variantId || '';
    link.replaceWith(el);
    if (!variantId) {
      syncWithMainForm(el);
      el.querySelector('form').addEventListener('submit', () => syncWithMainForm(el), true);
      if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => syncWithMainForm(el)));
      }
    }
  }

  function enhance(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const links = Array.from(scope.querySelectorAll('a[href*="#add-to-cart"]')).filter((link) => marker(link) !== null);
    if (links.length === 0) return;
    if (!customElements.get('product-form') && !document.querySelector('script[src="' + productFormSrc + '"]')) {
      const script = document.createElement('script');
      script.src = productFormSrc;
      document.head.appendChild(script);
    }
    links.forEach(transform);
  }

  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
